const about = {
  hero: {
    eyebrow: "Кто мы",
    title:   "Надёжный партнёр в",
    titleEm: "недвижимости Дубая",
  },
  team: {
    eyebrow: "Познакомьтесь с экспертами",
    title:   "Наша",
    titleEm: "команда",
    sub:     "Познакомьтесь с экспертами, стоящими за нашим успехом: преданными, опытными и готовыми помочь вам достичь ваших целей в сфере недвижимости.",
    role:    "Менеджер по продажам",
  },
  body: {
    p1: "ProNet Real Estate — агентство в Дубае, специализирующееся на жилой и коммерческой недвижимости по всему ОАЭ. С более чем 12-летним опытом работы на рынке мы помогаем покупателям, продавцам, арендодателям и арендаторам уверенно ориентироваться в постоянно меняющемся рынке недвижимости Дубая.",
    p2: "Наша команда сертифицированных агентов хорошо знает ключевые районы Дубая: Даунтаун, Бизнес-Бэй, Пальма Джумейра, Собха Хартленд и другие — а также развивающиеся рынки Абу-Даби, Шарджи и Аджмана.",
    p3: "Мы убеждены, что покупка или аренда жилья должны быть простым и прозрачным процессом. Именно поэтому мы обеспечиваем поддержку на всех этапах: от первого поиска объекта до финальной передачи ключей.",
  },
  values: [
    { title: "Прозрачность",           desc: "Никаких скрытых комиссий. Никакого давления. Только честное сопровождение на каждом этапе." },
    { title: "Экспертиза",             desc: "12+ лет на рынке ОАЭ. Мы знаем, какие районы дают реальную ценность." },
    { title: "Клиент прежде всего",    desc: "Ваши цели определяют каждую нашу рекомендацию." },
    { title: "Полный сервис",          desc: "От поиска до оформления сделки — мы сопровождаем весь путь." },
  ],
  cta: {
    title:   "Найдём вашу",
    titleEm: "недвижимость",
    sub:     "Свяжитесь с нами — наша команда готова помочь 7 дней в неделю.",
    send:    "Отправить сообщение",
  },
};

export default about;
